import Http from "./base-http";

class Department extends Http {
  deleteDepartment(id) {
    return this.destroy(id);
  }
  addDepartment(variables) {
    return this.create(variables);
  }
}

const departmentObj = new Department({
  modelUrlPrefix : "department"
});

export default departmentObj;
